import React, { lazy, Suspense } from 'react';

const LazyEstimates = lazy(() => import('./Estimates'));

const Estimates = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }|any) => (
  <Suspense fallback={null}>
    <LazyEstimates {...props} />
  </Suspense>
);

export default Estimates;
